<template lang="pug">
  .form
    .form__elem
      .form-elem.form-elem_horizontal
        .form-elem__title Район
        .form-elem__main
          select.select(
          v-model="localArea"
          @change="changeAreaValue($event)"
          )
            option(
            v-for="item in areasList"
            :value="item.id"
            ) {{item.name}}
    .form__elem
      .form-elem.form-elem_horizontal(
      :class="{ 'form-elem_error' : fieldsErrors.school_address.value }"
      )
        .form-elem__title Адрес
        .form-elem__main
          input.input(
          v-model="localSchoolAddress"
          @input="resetError('school_address')"
          maxlength="50"
          )
    .form__elem
      .form-elem.form-elem_horizontal(
      :class="{ 'form-elem_error' : fieldsErrors.school_name.value }"
      )
        .form-elem__title {{isAccompanying ? "Место работы" : "Школа или лицей"}}
        .form-elem__main
          input.input(
          v-model="localSchoolName"
          @input="resetError('school_name')"
          maxlength="50"
          )

</template>

<script>
export default {
  name: "form-educational-institution",
  props: {
    areasList: {
      type: [Array, Object],
      default: null,
    },
    area: {
      type: [Boolean, Object, String, Number],
      default: null,
    },
    schoolAddress: {
      type: String,
      default: "",
    },
    schoolName: {
      type: String,
      default: "",
    },
    isAccompanying: {
      type: Boolean,
      default: false,
    },
    fieldsErrors: {
      type: Object,
      default: () => ({}),
    },
    resetError: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    localArea: {
      get() {
        return this.area;
      },
      set() {},
    },
    localSchoolAddress: {
      get() {
        return this.schoolAddress;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "school_address"]);
      },
    },
    localSchoolName: {
      get() {
        return this.schoolName;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "school_name"]);
      },
    },
  },
  methods: {
    changeAreaValue(e) {
      this.$emit("onChangeValue", [e.target.value, "area"]);
    },
  },
};
</script>
